import { render, staticRenderFns } from "./FrameworkItem.vue?vue&type=template&id=06f9bf8a&scoped=true&"
import script from "./FrameworkItem.vue?vue&type=script&lang=ts&"
export * from "./FrameworkItem.vue?vue&type=script&lang=ts&"
import style0 from "./FrameworkItem.vue?vue&type=style&index=0&id=06f9bf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9bf8a",
  null
  
)

export default component.exports